import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService } from 'ngx-alerts';
import { NgxSpinnerService } from 'ngx-spinner';
import { DlaService } from 'src/app/shared/dla.service';

@Component({
  selector: 'app-send-mail-facilitator',
  templateUrl: './send-mail-facilitator.component.html',
  styleUrls: ['./send-mail-facilitator.component.css']
})
export class SendMailFacilitatorComponent implements OnInit {
  mainPageTitle = 'Send Mail to Facilitator';
  messageForm: FormGroup;
  heading = "";
  submitted = false;
  recipients: any = [];
  userData: any;

  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private alertService: AlertService,
    private dlaService: DlaService) {
    this.messageForm = this.formBuilder.group({
      sendTo: ['', Validators.required],
      subject: ['', Validators.required],
      messageBody: ['', Validators.required],
    });
  }


  get f() { return this.messageForm.controls; }

  ngAfterViewInit(): void {
    this.getRecipients();
  }

  ngOnInit(): void {
    this.loadScripts();
    this.userData = JSON.parse(localStorage.getItem('dla_student'));


  }

  getRecipients() {

    this.spinner.show();
    this.dlaService.getRecipients("facilitator", this.userData.user_id, this.userData.courses).subscribe(
      (data: any) => {
        this.spinner.hide();
        const error: boolean = data.error;
        if (!error) {
          // console.log(data);
          this.recipients = data;
        } else {
          //this.alertService.danger(data.message);
        }
      },
      error => {
        this.spinner.hide();
        // this.alertService.danger('An error occurred, Please try again');
      }
    );
  }


  onSubmit() {
    this.submitted = true;

    const textarea = document.getElementsByClassName('note-editable panel-body');

    this.messageForm.controls["messageBody"].setValue(textarea[0].innerHTML);

    // stop here if form is invalid
    if (this.messageForm.invalid) {
      this.alertService.danger("Please fill all required fields");
      return;
    }


    this.spinner.show();
    this.dlaService.sendMessage(this.messageForm.value.subject, this.messageForm.value.messageBody, this.userData.user_id, this.messageForm.value.sendTo).subscribe(
      (data: any) => {
        this.spinner.hide();
        const error: boolean = data.error;
        if (!error) {
          this.alertService.success(data.message);
          this.spinner.hide();
          this.messageForm.reset();
          textarea[0].innerHTML = "";
          //this.dialogRef.close();
        } else {
          this.spinner.hide();
          this.alertService.danger(data.message);
        }
      },
      error => {
        this.spinner.hide();
        this.alertService.danger('An error occurred, Please try again');
      }
    );
  }

  loadScripts() {
    const dynamicScripts = [
      'assets/js/vendor/jquery-1.11.3.min.js',
      'assets/js/bootstrap.min.js',
      'assets/js/wow.min.js',
      'assets/js/jquery-price-slider.js',
      'assets/js/jquery.meanmenu.js',
      'assets/js/owl.carousel.min.js',
      'assets/js/jquery.sticky.js',
      'assets/js/jquery.scrollUp.min.js',
      'assets/js/scrollbar/jquery.mCustomScrollbar.concat.min.js',
      'assets/js/scrollbar/mCustomScrollbar-active.js',
      'assets/js/metisMenu/metisMenu.min.js',
      'assets/js/metisMenu/metisMenu-active.js',
      'assets/js/summernote/summernote.min.js',
      'assets/js/summernote/summernote-active.js',
      'assets/js/tab.js',
      'assets/js/sparkline/jquery.sparkline.min.js',
      'assets/js/sparkline/jquery.charts-sparkline.js',
      'assets/js/calendar/moment.min.js',
      'assets/js/calendar/fullcalendar.min.js',
      'assets/js/calendar/fullcalendar-active.js',
      'assets/js/plugins.js',
      'assets/js/main.js'
    ];
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < dynamicScripts.length; i++) {
      const node = document.createElement('script');
      node.src = dynamicScripts[i];
      node.type = 'text/javascript';
      node.async = false;
      node.charset = 'utf-8';
      document.getElementsByTagName('head')[0].appendChild(node);
    }
  }

}
